import React, { useEffect, useState } from "react";
import api, { API_URL, BACKEND_URL } from "./util/api";
import "./gallery.css";

export default function GalleryPage() {

  const [categories, setCategories] = useState([]);
  const [images, setImages] = useState([]);
  const [viewerIndex, setViewerIndex] = useState(null);

  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [category, setCategory] = useState("");
  const [search, setSearch] = useState("");

  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);



  // LOAD CATEGORIES
  useEffect(() => {

    api.get(API_URL + "/gallery/categories")
      .then(res => {
        setCategories(res.data.data);
      });

  }, []);



  // LOAD GALLERY
  useEffect(() => {

    loadGallery(true);

  }, [category, search]);



  const loadGallery = (reset = false) => {

    if (reset) {
      setLoading(true)
    } else {
      setLoadingMore(true)
    }

    let nextPage = reset ? 1 : page;

    api.get(API_URL + "/gallery", {
      params: {
        page: nextPage,
        category,
        search
      }
    }).then(res => {

      let data = res.data.data.data;

      if (reset) {
        setImages(data);
        setPage(2);
      } else {
        setImages(prev => [...prev, ...data]);
        setPage(prev => prev + 1);
      }

      setHasMore(res.data.data.next_page_url !== null);

      setLoading(false)
      setLoadingMore(false)

    });

  };



  // INFINITE SCROLL
  useEffect(() => {

    const handleScroll = () => {

      if (
        window.innerHeight + window.scrollY >=
        document.body.offsetHeight - 200
      ) {

        if (hasMore && !loadingMore) {
          loadGallery();
        }

      }

    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);

  }, [images, hasMore, loadingMore]);



  // LIGHTBOX NAVIGATION
  const nextImage = (e) => {
    e.stopPropagation();
    setViewerIndex((viewerIndex + 1) % images.length);
  };

  const prevImage = (e) => {
    e.stopPropagation();
    setViewerIndex((viewerIndex - 1 + images.length) % images.length);
  };



  return (

    <section style={{ marginTop: "2cm" }}>

      <div className="gallery-wrapper">

        <h1 className="gallery-title">Photo Gallery</h1>



        {/* SEARCH */}

        <div className="search-wrapper">
          <input
            className="search-box"
            placeholder="Search gallery..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>



        {/* CATEGORY */}

        <div className="category-bar">

          <button
            className={category === "" ? "active" : ""}
            onClick={() => setCategory("")}
          >
            All
          </button>

          {categories.map(cat => (

            <button
              key={cat.id}
              className={category === cat.id ? "active" : ""}
              onClick={() => setCategory(cat.id)}
            >
              {cat.name}
            </button>

          ))}

        </div>



        {/* SKELETON LOADER */}

        {loading && (

          <div className="gallery-grid">

            {Array(9).fill().map((_, i) => (

              <div key={i} className="gallery-card skeleton"></div>

            ))}

          </div>

        )}



        {/* GRID */}

        {!loading && (

          <div className="gallery-grid">

            {images.map((img, i) => (

              <div
                key={i}
                className="gallery-card"
                onClick={() => setViewerIndex(i)}
              >

                <img
                  src={BACKEND_URL + img.image}
                  alt=""
                />

                <div className="gallery-overlay">
                  {img.category.name}
                </div>

              </div>

            ))}

          </div>

        )}



        {/* LOAD MORE SPINNER */}

        {loadingMore && (

          <div className="load-more">
            <div className="spinner"></div>
          </div>

        )}



        {/* LIGHTBOX */}

        {viewerIndex !== null && (

          <div className="lightbox" onClick={() => setViewerIndex(null)}>

            <button
              className="close-btn"
              onClick={() => setViewerIndex(null)}
            >
              ✕
            </button>

            <button
              className="nav prev"
              onClick={prevImage}
            >
              ❮
            </button>

            <img
              className="lightbox-img"
              src={BACKEND_URL + images[viewerIndex].image}
              alt=""
            />

            <button
              className="nav next"
              onClick={nextImage}
            >
              ❯
            </button>

          </div>

        )}

      </div>

    </section>

  );
}